import { useState, useEffect } from "react";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db, auth } from "../Services/firebase-config";

export const useEventEnrollment = (eventId) => {
  const [enrollment, setEnrollment] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkEnrollment = async () => {
      if (!auth.currentUser || !eventId) {
        setEnrollment(null);
        setLoading(false);
        return;
      }

      try {
        const enrollmentRef = doc(
          db,
          "eventEnrollments",
          `${auth.currentUser.uid}_${eventId}`,
        );
        const snap = await getDoc(enrollmentRef);
        setEnrollment(snap.exists() ? snap.data() : null);
      } catch (err) {
        console.error("Error checking enrollment:", err);
        setEnrollment(null);
      } finally {
        setLoading(false);
      }
    };

    checkEnrollment();
  }, [eventId]);

  const enrollInEvent = async (id, kycData, eventTitle) => {
    if (!auth.currentUser) throw new Error("User not authenticated");

    const enrollmentRef = doc(
      db,
      "eventEnrollments",
      `${auth.currentUser.uid}_${id}`,
    );

    const enrollmentData = {
      userId: auth.currentUser.uid,
      eventId: id,
      eventTitle: eventTitle || "",
      ...kycData,
      enrolledAt: serverTimestamp(),
    };

    await setDoc(enrollmentRef, enrollmentData, { merge: true });
    setEnrollment(enrollmentData);
  };

  return { enrollment, loading, enrollInEvent };
};
